import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-raw-material",
  "use": "icon-raw-material-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-raw-material\"><g fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\"><path d=\"m3 7l7-4l11 4M3 7v5l11 4l7-4V7M3 7l11 4l7-4\" /><path d=\"M3 12v5l11 4l7-4v-5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol